import Modal from 'components/commons/modal/Modal2';
import React from 'react';

type Props = {
  isShow: boolean;
  hide: () => void;
  onContinueInput: () => void;
  onQuit: () => void;
};

export const ExitSetHowToSaveModal = ({
  hide,
  isShow,
  onQuit: onCancel,
  onContinueInput: onContinue,
}: Props): React.ReactElement => {
  return (
    <>
      <Modal {...{ isShow, close: hide }}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-col text-bluegray-700">
            <div className="flex flex-row">
              <div
                className="icon-close ml-auto text-gray-500 cursor-pointer"
                onClick={hide}
              />
            </div>
            <div className="font-bold text-bluegray-700 text-lg">
              入力内容を破棄して戻りますか？
            </div>
            <div className="flex lex-row mt-4 text-bluegray-700 text-sm">
              <div className="icon-alert items-start mr-2 mt-1 text-yellow-375"></div>
              <div>戻ると入力した内容は破棄されます。</div>
            </div>
            <div className="p-4 mt-4 flex flex-col">
              <button
                className="text-white rounded-lg bg-tradewell font-bold py-2 flex flex-row items-center justify-center text-base"
                onClick={onContinue}>
                入力を続ける
              </button>
              <button
                className="text-bluegray-500 py-2 mt-2 flex flex-row items-center justify-center text-sm"
                onClick={onCancel}>
                入力内容を破棄して戻る
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
